<div class="row">
  <div class="col-lg-4 d-none d-lg-block">
    <sb-card [loading]="loading" [hidden]="cacheLock">
      <div card-header>
        {{'lang.admin.admin'| translate}}
      </div>
      <div card-body>
        <div>
          <button class="btn btn-danger btn-circle" type="button" [disabled]="cacheLock"
                  (click)="deletePlaylistCache()">{{'lang.admin.deletePlaylistCache'|translate}}</button>
          {{'lang.admin.deletePlaylistCacheDescription'|translate}}
        </div>
      </div>
    </sb-card>
  </div>
  <div class="col-lg-4">
    <sb-card [loading]="loading">
      <div card-header>
        {{'lang.admin.admin' | translate}}
      </div>
      <div card-header-more>
        <sb-icon *ngIf="locked" icon="lockClosed"></sb-icon>
        <sb-icon *ngIf="!locked" icon="lockOpen"></sb-icon>
      </div>
      <div card-body>
        <div style="text-align: center; font-size: 6rem;">
          <sb-icon *ngIf="locked" icon="lockClosed"></sb-icon>
          <sb-icon *ngIf="!locked" icon="lockOpen"></sb-icon>
          <br>
          <p *ngIf="locked" style="font-size: 3rem;">{{'lang.adminOverview.SignAdminCredentials' | translate}}</p>
          <p *ngIf="!locked" style="font-size: 3rem;">{{'lang.adminOverview.dontForget>SignOut' | translate}}</p>
        </div>
      </div>
    </sb-card>
  </div>
  <div class="col-lg-4 d-none d-lg-block">
    <div class="curvedarrowwrapper">
      <div class="curvedarrow">

      </div>
    </div>
  </div>
</div>
